<template>
    <!-- banner左右轮播 -->
    <div class="banner_wrap">
        <div class="swiper23" v-if="is_show">
            <div
                class="swiper-container-ac" 
                @click.stop.prevent="openNative('record_list_page')"
            >
                <!-- swiper-no-swiping -->
                <div class="swiper-wrapper ">
                    <div class="swiper-slide" v-for="(item, i) in top_list" :key="'ing_' + i">
                        <span
                            class="banner-item"
                        >
                            <!-- <i>{{ item.advert_content }}</i> -->
                            <div
                                class="notice-bar-wrap"
                                @click.stop.prevent="openDetail(item)"
                            >
                                {{ item.content }}
                            </div>
                            <button @click.stop.prevent="close"></button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { source } from "@/utils/urlQuery";
export default {
    components: {

    },
    data() {
        return {
            top_list: [],
            swiper23: null,
            date: null,
            is_show: false,
            saveKeys: "",
        }
    },
    props: {
        noticeList: {
            type: Array,
            default: () => {
                return []
            }
        },
        teacherInfo: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    created() {
        let saveKeys = "show_banner_by_chatting_room" + this.teacherInfo.u_id;
        this.saveKeys = saveKeys;
        this.date = localStorage.getItem(saveKeys);
        if (this.date != new Date().setHours(0, 0, 0, 0)) {
            this.getdata();
        }
    },
    mounted() {

    },
    methods: {
        swiper() {
            //战绩榜 滚动事件
            if (this.swiper23) {
                //清楚 已有滚动
                this.swiper23.destroy(true);
            }

            let timer = 15 * 1000;
            if (this.top_list.length > 1) {
                this.$nextTick(() => {
                    this.swiper23 = new Swiper(".swiper-container-ac", {
                        direction: "vertical",
                        autoplay: {
                            delay: timer,
                            disableOnInteraction: false,
                        },
                        loop: false,
                    });
                });
            }
        },
        close() {
            this.date = new Date().setHours(0, 0, 0, 0);
            localStorage.setItem(this.saveKeys, new Date().setHours(0, 0, 0, 0));
            if (this.swiper23) {
                this.swiper23.destroy(true);
                this.swiper23 = null;
            }
            this.is_show = false;
        },
        async getdata() {
            this.top_list = this.noticeList;

            if (this.top_list.length > 0) {
                this.is_show = true;
                this.$nextTick(() => {
                    this.swiper();
                })
            }
        },
        openDetail(item) {
            if(item.type == 'bulletin') {
                return;
            }
            if(item.link_kind == 'vip' && source != 'android') {
                this.openNative('adv_live_msg', {
                    url: `/up/app/advLiveMsg?id=${item.link_id}`
                });
            } else {
                this.openNative('jump_type_page', {
                    o_kind: item.link_kind,
                    id: item.link_id,
                    name: item.content
                });
            }
        },
        

        // 跳转APP页面
        openNative(type, query = {}) {
            let params = {
                kind: type, // 类型
            };

            // 同步传参
            params = {
                ...params,
                ...query
            }

            switch(type) {
                case "record_list_page": // 战绩榜页面
                    break;
                case "adv_live_msg":
                    break;
                case "jump_type_page":
                    break;
            }

            this.$srH5CallNativeMethodApp('call_Native',params)
        },

    },
    computed: {
    },

}

</script>
<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";
.banner_wrap {
    background: #fff;
    z-index: 1;
    position: relative;
	border-bottom: 0.5px solid $a-bordr-c;
}

.swiper23 {
    box-sizing: border-box;
    width: 100%;
    height: 42px;
    line-height: 42px;
    overflow: hidden;

    .swiper-container-ac {
        height: 100%;
        background: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/recordListLeftTxt.svg") no-repeat;
        background-size: 41px 23px;
        background-position: 10px center;
    }

    .swiper-wrapper {
        height: 42px !important;
    }

    .swiper-slide {
        // height: 100% !important;

        .banner-item {
            padding-left: 61px;
            padding-right: 35px;
            font-size: 14px;
            font-weight: 400;
            color: #C6010A;
            position: relative;
            height: 40px;
            line-height: 40px;
            display: block;
            position: relative;
        
            >i {
                font-style: normal;
                display: inline-block;
                max-width: 92%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        
            .notice-bar-wrap {
                width: 92%;
            }
        
            > button {
                width: 20px;
                height: 20px;
                position: absolute;
                right: 15px;
                top: 50%;
                transform: translateY(-50%);
                background-color: transparent;
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/recordListCloseIcon.svg");
                background-repeat: no-repeat;
                background-size: 20px 20px;
                background-position: center;
                border: none;
            }
        }

        div {
            box-sizing: border-box;
            height: 100%;
            text-align: left;
        }
    }
}
</style>